import axios from 'axios'

export default {
  namespaced: true,
  state: {
    workClientAddressGrid: [],
    workClientAddressAll: [],
    workClientAddressShow: null,
    pageData: null,
  },
  mutations: {
    setWorkClientAddressGrid(state, payload) {
      state.workClientAddressGrid = payload
    },
    setWorkClientAddressAll(state, payload) {
      state.workClientAddressAll = payload
    },
    setWorkClientAddressShow(state, payload) {
      state.workClientAddressShow = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
  },
  getters: {
    workClientAddressGrid: (state) => {
      return state.workClientAddressGrid
    },
    workClientAddressAll: (state) => {
      return state.workClientAddressAll
    },
    workClientAddressShow: (state) => {
      return state.workClientAddressShow
    },
    pageData: (state) => {
      return state.pageData
    },
  },
  actions: {
    onWorkClientAddressGrid({ commit, rootState }, { limit, page, id, sort, search }) {
      commit('setLoadingAnimation', true, { root: true })
      let url =
        rootState.apiDomain +
        '/api/admin/work/client/address/grid?limit=' +
        limit +
        '&page=' +
        page +
        '&filter[]=work_client_id:' +
        id
      if (sort) {
        url = url + '&order[]=' + sort.param + ':' + sort.value
      } else {
        url = url + '&order[]=city:asc'
      }
      if (search) url = url + '&search=' + search
      return new Promise((resolve, reject) => {
        axios({
          url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientAddressGrid', resp.data.data)
            commit('setLoadingAnimation', false, { root: true })
            commit('setPageData', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimation', false, { root: true })
            reject(err)
          })
      })
    },
    onWorkClientAddressAll({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/client/address/grid?limit=0' +
            '&order[]=city:asc',
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientAddressAll', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientAddressShow({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/address/' + id,
          id: id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientAddressShow', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientAddressCreate({ dispatch, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/address',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
            dispatch('popup/onMessage', {
              message: rootState.translations.notifications['uspeshno-dobavlen'],
              IsError: false
            }, {root: true})
          })
          .catch((err) => {
            reject(err)
            dispatch('popup/onMessage', {IsError: true}, {root: true})
          })
      })
    },
    onWorkClientAddressUpdate({ dispatch, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/address',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
            dispatch('popup/onMessage', {IsError: false}, {root: true})
          })
          .catch((err) => {
            reject(err)
            dispatch('popup/onMessage', {IsError: true}, {root: true})
          })
      })
    },
    onWorkClientAddressDelete({ rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/address/' + id,
          id: id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
